import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
import { colors } from '../constants/colors';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const IconEyeInvisible = ({
  width = 24,
  height = 24,
  color = colors.gray2,
  ...rest
}: Props) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      //   xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <G clipPath="url(#clip0_661_724)">
        <Path
          d="M16.1 13.3l-1.45-1.45c.15-.784-.075-1.517-.675-2.2-.6-.684-1.375-.95-2.325-.8L10.2 7.4a4.24 4.24 0 01.863-.3c.291-.067.604-.1.937-.1 1.25 0 2.313.437 3.188 1.312.874.875 1.312 1.938 1.312 3.188 0 .333-.033.646-.1.937-.067.292-.167.58-.3.863zm3.2 3.15l-1.45-1.4a10.951 10.951 0 001.688-1.588A8.898 8.898 0 0020.8 11.5c-.833-1.684-2.03-3.021-3.588-4.013C15.654 6.496 13.917 6 12 6c-.483 0-.958.033-1.425.1a9.623 9.623 0 00-1.375.3L7.65 4.85A11.081 11.081 0 0112 4c2.517 0 4.758.696 6.725 2.087C20.692 7.48 22.117 9.283 23 11.5a11.696 11.696 0 01-1.512 2.737A11.007 11.007 0 0119.3 16.45zm.5 6.15l-4.2-4.15c-.583.183-1.17.32-1.762.412-.592.092-1.205.138-1.838.138-2.517 0-4.758-.696-6.725-2.088C3.308 15.521 1.883 13.717 1 11.5c.35-.883.792-1.704 1.325-2.463A11.514 11.514 0 014.15 7L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4zM5.55 8.4c-.483.433-.925.908-1.325 1.425A9.015 9.015 0 003.2 11.5c.833 1.683 2.03 3.02 3.587 4.012C8.346 16.504 10.083 17 12 17c.333 0 .658-.021.975-.063.317-.041.642-.087.975-.137l-.9-.95c-.183.05-.358.087-.525.112A3.539 3.539 0 0112 16c-1.25 0-2.313-.438-3.188-1.313C7.939 13.812 7.5 12.75 7.5 11.5c0-.184.013-.358.037-.525.026-.167.063-.342.113-.525L5.55 8.4z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_661_724">
          <Path fill={color} d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
